export const AR_FIXED_HOLIDAYS = [
  { month:1,day:1,name:"Año Nuevo" },{ month:2,day:24,name:"Carnaval" },{ month:2,day:25,name:"Carnaval" },
  { month:3,day:24,name:"Día Nacional de la Memoria" },{ month:4,day:2,name:"Día del Veterano de Malvinas" },
  { month:5,day:1,name:"Día del Trabajo" },{ month:5,day:25,name:"Revolución de Mayo" },
  { month:6,day:20,name:"Paso a la Inmortalidad del Gral. Belgrano" },{ month:7,day:9,name:"Día de la Independencia" },
  { month:8,day:17,name:"Paso a la Inmortalidad del Gral. San Martín" },{ month:10,day:12,name:"Diversidad Cultural" },
  { month:11,day:20,name:"Soberanía Nacional" },{ month:12,day:8,name:"Inmaculada Concepción" },{ month:12,day:25,name:"Navidad" },
];

export const JEWISH_HOLIDAYS = {
  2025:[
    {date:"2025-03-13",name:"Ta'anit Ester"},{date:"2025-03-14",name:"Purim"},{date:"2025-03-15",name:"Shushan Purim"},
    {date:"2025-04-13",name:"Erev Pesaj"},{date:"2025-04-14",name:"Pesaj (1er día)"},{date:"2025-04-15",name:"Pesaj (2do día)"},
    {date:"2025-04-20",name:"Pesaj (7mo día)"},{date:"2025-04-21",name:"Pesaj (8vo día)"},
    {date:"2025-05-02",name:"Yom HaShoá"},{date:"2025-05-09",name:"Yom HaZikaron"},{date:"2025-05-11",name:"Yom HaAtzmaut"},
    {date:"2025-05-22",name:"Lag BaOmer"},{date:"2025-06-01",name:"Shavuot (1er día)"},{date:"2025-06-02",name:"Shavuot (2do día)"},
    {date:"2025-08-03",name:"Tishá BeAv"},
    {date:"2025-09-22",name:"Erev Rosh Hashaná"},{date:"2025-09-23",name:"Rosh Hashaná (1er día)"},{date:"2025-09-24",name:"Rosh Hashaná (2do día)"},
    {date:"2025-10-01",name:"Erev Iom Kipur"},{date:"2025-10-02",name:"Iom Kipur"},
    {date:"2025-10-06",name:"Erev Sucot"},{date:"2025-10-07",name:"Sucot (1er día)"},{date:"2025-10-08",name:"Sucot (2do día)"},
    {date:"2025-10-14",name:"Sheminí Atzeret"},{date:"2025-10-15",name:"Simját Torá"},
    {date:"2025-12-14",name:"Janucá (1)"},{date:"2025-12-15",name:"Janucá (2)"},{date:"2025-12-16",name:"Janucá (3)"},
    {date:"2025-12-17",name:"Janucá (4)"},{date:"2025-12-18",name:"Janucá (5)"},{date:"2025-12-19",name:"Janucá (6)"},
    {date:"2025-12-20",name:"Janucá (7)"},{date:"2025-12-21",name:"Janucá (8)"},
  ],
  2026:[
    {date:"2026-03-03",name:"Ta'anit Ester"},{date:"2026-03-04",name:"Purim"},{date:"2026-03-05",name:"Shushan Purim"},
    {date:"2026-04-01",name:"Erev Pesaj"},{date:"2026-04-02",name:"Pesaj (1er día)"},{date:"2026-04-03",name:"Pesaj (2do día)"},
    {date:"2026-04-08",name:"Pesaj (7mo día)"},{date:"2026-04-09",name:"Pesaj (8vo día)"},
    {date:"2026-04-20",name:"Yom HaShoá"},{date:"2026-04-28",name:"Yom HaZikaron"},{date:"2026-04-29",name:"Yom HaAtzmaut"},
    {date:"2026-05-11",name:"Lag BaOmer"},{date:"2026-05-20",name:"Shavuot (1er día)"},{date:"2026-05-21",name:"Shavuot (2do día)"},
    {date:"2026-07-23",name:"Tishá BeAv"},
    {date:"2026-09-10",name:"Erev Rosh Hashaná"},{date:"2026-09-11",name:"Rosh Hashaná (1er día)"},{date:"2026-09-12",name:"Rosh Hashaná (2do día)"},
    {date:"2026-09-19",name:"Erev Iom Kipur"},{date:"2026-09-20",name:"Iom Kipur"},
    {date:"2026-09-24",name:"Erev Sucot"},{date:"2026-09-25",name:"Sucot (1er día)"},{date:"2026-09-26",name:"Sucot (2do día)"},
    {date:"2026-10-02",name:"Sheminí Atzeret"},{date:"2026-10-03",name:"Simját Torá"},
    {date:"2026-12-04",name:"Janucá (1)"},{date:"2026-12-05",name:"Janucá (2)"},{date:"2026-12-06",name:"Janucá (3)"},
    {date:"2026-12-07",name:"Janucá (4)"},{date:"2026-12-08",name:"Janucá (5)"},{date:"2026-12-09",name:"Janucá (6)"},
    {date:"2026-12-10",name:"Janucá (7)"},{date:"2026-12-11",name:"Janucá (8)"},
  ],
  2027:[
    {date:"2027-02-22",name:"Purim"},{date:"2027-03-22",name:"Pesaj (1er día)"},{date:"2027-03-23",name:"Pesaj (2do día)"},
    {date:"2027-03-28",name:"Pesaj (7mo día)"},{date:"2027-03-29",name:"Pesaj (8vo día)"},
    {date:"2027-05-09",name:"Shavuot (1er día)"},{date:"2027-05-10",name:"Shavuot (2do día)"},
    {date:"2027-08-31",name:"Rosh Hashaná (1er día)"},{date:"2027-09-01",name:"Rosh Hashaná (2do día)"},
    {date:"2027-09-09",name:"Iom Kipur"},{date:"2027-09-14",name:"Sucot (1er día)"},{date:"2027-09-15",name:"Sucot (2do día)"},
    {date:"2027-09-21",name:"Sheminí Atzeret"},{date:"2027-09-22",name:"Simját Torá"},
  ]
};

export const getHolidaysForYear = (year) => {
  const fixed = AR_FIXED_HOLIDAYS.map(h=>({
    date:`${year}-${String(h.month).padStart(2,'0')}-${String(h.day).padStart(2,'0')}`,
    name:h.name, type:'argentina'
  }));
  const jewish = (JEWISH_HOLIDAYS[year]||[]).map(h=>({...h,type:'jewish'}));
  return [...fixed,...jewish].sort((a,b)=>a.date.localeCompare(b.date));
};
